import { RxCoverageApplicationState } from "../RxCoverageApplication";

export const getFacilityName = (state: RxCoverageApplicationState) =>
  state.referral.facilityName;
